import client from './apiclient.js';

const recipient = {
    get: client.createConcatRequestMethod('get', '/api/recipient/get/'),
    getByCustomer: client.createConcatRequestMethod('get', '/api/recipient/getByCustomer/'),
    getAllByCurrentCustomer: client.createRequestMethod('get', '/api/recipient/getAllByCurrentCustomer'),
    getByCurrentCustomerByAnimalType: client.createConcatRequestMethod(
        'get',
        '/api/recipient/GetByCurrentCustomerByAnimalType/'
    ),
    getFirstDisplayableRecipientId: client.createConcatRequestMethod(
        'get',
        '/api/recipient/GetFirstDisplayableRecipientId/'
    ),
    getBreedValues: client.createConcatRequestMethod('get', '/api/recipient/GetBreedValues?isHorse='),
    getGenderValues: client.createConcatRequestMethod('get', '/api/recipient/GetGenderValues?isHorse='),
    getLivingSituationValues: client.createConcatRequestMethod(
        'get',
        '/api/recipient/GetLivingSituationValues?isHorse='
    ),
    restartSmartPakForAccount: client.createConcatRequestMethod('get', '/api/SmartPakItem/RestartSmartPakForAccount/'),
    post: client.createRequestMethod('post', '/api/recipient/post/'),
    put: client.createConcatRequestMethod('put', '/api/recipient/put/')
};

export default recipient;
